import React, { useEffect, useState } from 'react'
import LoadSpinner from '../../../components/load-spinner/LoadSpinner';
import CustomTable from '../../../components/custom-table/CustomTable';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'react-bootstrap';
import useDoor from '../../../hooks/useDoor';
import { toast } from 'react-toastify';
import { getDateFormatted, getFormatOraInput } from '../../../utils/dateUtils';
import useLog from '../../../hooks/useLog';
import { loadingWrapper } from '../../../utils/loadingWrapper';
import { logTypeClass, logTypeIcon, logTypeToString } from '../../../utils/logUtils';

const DashboardHistory = () => {
    const [doorList,setDoorList] = useState([]);
    const [dataTable, setDataTable] = useState([]);

    const [filter,setFilter] = useState({
        startDate: getFormatOraInput( new Date(new Date().getTime() - 30 * 24 * 60 * 60 * 1000)),
        endDate: getFormatOraInput(new Date()),
        doorId: "all"
    });

    const { getDoors,} = useDoor();
    const { logLoading, getHistoryLogs } = useLog();

    const historyLoading = false;

        const headerTable = [
        { label: "Ufficio", field: "doorName", width: 270 },
        { label: "Utente", field: "username", width: 270 },
        { label: "Evento", field: "event", width: 270 },
        { label: "Data", field: "eventDate", width: 270 },
    ];

    useEffect(()=>{
        getDoors(
                (data)=>{
                    setDoorList(data.content)
                },
                ()=>{
                  toast.error("Errore nel ricevere i dati relativi alle  porte")
                },
                false
              )
    },[]);

    const searchHistory = () => {
        getHistoryLogs(
            {...filter, startDate: new Date(new Date(filter.startDate).setHours(0,0,0)).getTime(), endDate: new Date(new Date(filter.endDate).setHours(23,59,59,)).getTime()},
            (data)=>{
                data.forEach(element => {
                        element.doorName = doorList.find((door)=>door.id === parseInt(element.doorCode))?.name || "N/A";
                        element.event = logTypeToString(element.type);
                        element.eventDate = getDateFormatted(new Date(element.eventDate),"DD/MM/yyyy HH:mm");
                });
                setDataTable(data)
            },
            (error)=>{
                toast.error(typeof error === "string" ? error : "Errore nel recupero dello storico");
            }
        )

    }

    const onChangeFilter = (e) => {
        const { name, value } = e.target;
        setFilter((prev) => ({ ...prev, [name]: value }));
    }

  return (
    <>
      <div className="container-fluid">
        <div className='row px-3'>
          <div className="d-flex align-items-center justify-content-between mb-4 px-1">
            <h1 className="h1 mb-2 text-primary-custom">Dashboard Storico</h1>
          </div>
        </div>
        <div className='row'>
            <div className='col-4 d-flex flex-column'>
                <label>Data Inizio</label>
                <input type='date' onChange={onChangeFilter} name='startDate' value={filter.startDate} max={getFormatOraInput(new Date())} className='form-control' />
            </div>
            <div className='col-4 d-flex flex-column'>
                <label>Data Fine</label>
                <input type='date' onChange={onChangeFilter} name='endDate' value={filter.endDate} min={getFormatOraInput(new Date(filter.startDate))} className='form-control' />
            </div>
            <div className='col-3 d-flex flex-column'>
                <label>Ufficio</label>
                <select className='form-select' onChange={onChangeFilter} value={filter.doorId} name='doorId' >
                    <option value={"all"}>Tutti gli uffici</option>
                    {doorList.map((door)=>(
                        <option key={door.id} value={door.id}>{door.name}</option>
                    ))}
                </select>
            </div>
            <div className='col-1 d-flex align-items-end'>
                <Button className='btn-green' disabled={logLoading} onClick={searchHistory} variant='primary'>
                    {loadingWrapper(
                        logLoading,
                        <>Cerca</>
                    )}
                </Button>
            </div>
        </div>
        <div className="row mb-3">
          {historyLoading
          ?<LoadSpinner/>
          :<CustomTable
            clickIcon={faMagnifyingGlass}
            header={headerTable}
            data={dataTable}
            checkable={false}
            noClick={true}
            label='Eventi'
            iconField="type"
            iconLabel="Tipo"
            renderIcon={logTypeIcon}
            classFunction={logTypeClass}
            classField="type"
            />
          }
        </div>
      </div>
    </>
  )
}

export default DashboardHistory